import { getAuthAxiosBackend } from "@/helpers/axios"

class JobRecordServices{

    get(id){
        return getAuthAxiosBackend().get('JobRecords/getJobRecord/' + id.toString())
    }

    getByPersonId(personId){
        return getAuthAxiosBackend().get('JobRecords/getJobRecordByPersonId/' + personId.toString())
    }

    getAll(data = {}){
        return getAuthAxiosBackend().get('JobRecords/all', {params: data})
    }

    add(data){
        return getAuthAxiosBackend().post('JobRecords/addJobRecord', data)
    }

    edit(id, data){
        return getAuthAxiosBackend().put('JobRecords/updateJobRecord/' + id.toString(), data)
    }

    delete(id){
        return getAuthAxiosBackend().delete('JobRecords/softDeleteJobRecord/' + id.toString())
    }
}

export default new JobRecordServices()